import React, { useState } from "react";
import { Grid, GridCol } from "@mantine/core";
import CustomButton from "../../../components/CustomButton";
import passportImg from "../../../assets/passport.png";
import { ReactComponent as PassportBg } from "../../../assets/passport-bg.svg";
import { ReactComponent as VideoBtn } from "../../../assets/videoBtn.svg";
// import videoImg from "../../../assets/aeroplantwo.png";
import { Link } from "react-router-dom";
import videoImg from "../../../assets/Rectangle 2.png";
import videoImgMobile from "../../../assets/mobile-video-home.png";
import ThumbNailOne from "../../../assets/thumbnail 1.png";
import ThumbNailTwo from "../../../assets/thumbnail 2.png";

const About = () => {
  const [videoplay, setvideoplay] = useState(false);
  const desktopVideoRef = React.useRef(null);
  const mobileVideoRef = React.useRef(null);

  const handleVideoBtnClick = (ref) => {
    if (ref.current) {
      if (ref.current.paused) {
        ref.current.play();
      } else {
        ref.current.pause();
      }
    }
  };

  return (
    <div className="container-wrapper">
      <Grid>
        <GridCol span={{ base: 12, lg: 7 }}>
          <div className="about-text-wrapper">
            <h3 className="sub-header-red">About Fly n’ Claim</h3>
            <h1 className="header" style={{ width: "90%" }}>
              We handle your claims while you focus on your travels
            </h1>
            <p className="sub-header" style={{ width: "60%" }}>
              Fly n’ Claim specializes in helping travelers who’ve faced flight
              disruptions. From delays and cancellations to lost or damaged
              luggage, we fight for your rights and ensure you receive the
              compensation you’re entitled to. Our experienced team manages the
              entire process, so you don’t have to.
            </p>
            <Link to={"/about-us"} className="learn-btn-wrapper">
              <CustomButton btnText={"Learn More About Us"} />
            </Link>
          </div>
        </GridCol>
        <GridCol
          span={{ base: 12, lg: 5 }}
          style={{
            width: "100%",
            margin: "40px auto",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div
            className="video-div desktop-wrapper"
            style={{ position: "relative" }}
          >
            {/* <img src={videoImg} className="img-full" /> */}

            {!videoplay && (
              <VideoBtn
                className="absolute-center"
                style={{ cursor: "pointer", zIndex: 10 }}
                onClick={() => handleVideoBtnClick(desktopVideoRef)}
              />
            )}
            <video
              ref={desktopVideoRef}
              src="https://flyandclaim.odisoft.in/Flynclaim%20video%20final.mp4"
              className="img-full"
              poster={ThumbNailTwo}
              controls
              onPlay={() => setvideoplay(true)}
              onPause={() => setvideoplay(false)}
            ></video>
          </div>

          <div className="video-div mobile-wrapper">
            {/* <img src={videoImg} className="img-full" /> */}

            {!videoplay && (
              <VideoBtn
                className="absolute-center"
                style={{ cursor: "pointer", zIndex: 10 }}
                onClick={() => handleVideoBtnClick(mobileVideoRef)}
              />
            )}
            <video
              ref={mobileVideoRef}
              src="https://flyandclaim.odisoft.in/Flynclaim%20video%20final.mp4"
              className="img-full"
              poster={ThumbNailTwo}
              controls
              onPlay={() => setvideoplay(true)}
              onPause={() => setvideoplay(false)}
            ></video>
          </div>
        </GridCol>
      </Grid>
    </div>
  );
};

export default About;
